import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject, ItemAttrListDataSet, TableDataColumn } from '@mri/types';

@Pipe({
  name: 'tableCellRender',
})
export class TableCellRenderPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemAttrListDataSet, column: TableDataColumn): string | number | boolean {
    const value = this._getValue(prop, column);

    if(typeof value === 'number') return value.toFixed(2)

    return value;
  }

  private _getValue(prop: ItemAttrListDataSet, column: TableDataColumn): string | number | boolean {
    if(typeof column.getValue === 'function') return column.getValue(prop);
    return prop.element[column.key];
  }

}
